<template>
    <div :class="['search-locator-map', { 'loading': isStatus('loading'), 'is-empty': items.length === 0 }]"></div>
</template>

<script>
import { withStatus } from '@cherrypulp/vue-utils';
import {
    centerMap,
    clearMarkers,
    createInfowindow,
    createMap,
    createMarker,
    loadGoogleMaps,
    moveTo,
} from '../helpers/gmaps';

export default {
    mixins: [ withStatus() ],

    props: {
        apiKey: {
            default: null,
            type: String,
        },
        center: {
            default: false,
            type: Boolean,
        },
        items: {
            default() {
                return [];
            },
            type: Array,
        },
        infowindow: {
            default: null,
            type: String,
        },
    },

    data() {
        return {
            gmaps: null,
            historyBounds: null,
            historyCenter: null,
            infowindows: [],
            map: null,
            markers: [],
        };
    },

    watch: {
        items: {
            deep: true,
            handler(items) {
                this.createMarkers(items);
            },
        },
    },

    methods: {
        async animateTo(lat, lng) {
            if (this.hasMoved(lat, lng)) {
                this.setStatus('busy');

                const currentCenter = this.map.getCenter();
                await centerMap(currentCenter.lat(), currentCenter.lng(), 11, this.map);
                await moveTo(lat, lng, this.map);
                await centerMap(lat, lng, 12, this.map);

                this.$nextTick(() => {
                    this.setStatus('ready');
                });
            }
        },

        createMarkers(items = []) {
            if (items.length === 0) {
                return;
            }

            if (this.markers) {
                clearMarkers(this.markers);
                this.markers = [];
                this.infowindows = [];
            }

            const markers = [];
            const infowindows = [];

            items.forEach((item) => {
                const icon = item.icon ? item.icon : this.$searchlocator.icon;
                const marker = createMarker({
                    icon: icon.inactive,
                    ...item,
                }, this.map);
                markers.push(marker);

                if (this.infowindow) {
                    const infowindow = createInfowindow(marker, this.map, {
                        data: item,
                        icon,
                        onClose: () => this.doSelect(null, false),
                        // onOpen: async () => {
                        //     //await this.animateTo(item.lat, item.lng);
                        //     // marker.setIcon(icon.active);
                        // },
                        template: this.infowindow,
                    });
                    infowindows.push(infowindow);
                }

                this.gmaps.event.addListener(marker, 'click', () => this.doSelect(item));
            });

            this.markers = markers;
            this.infowindows = infowindows;

            centerMap(this.items[0].lat, this.items[0].lng, 6, this.map);
        },

        async doSelect(item = null, fireEvent = true) {
            console.log('SearchLocatorMap -> doSelect', item);
            this.setStatus('busy');

            // reset
            this.markers.forEach((marker) => {
                const found = this.items.find((i) => i.id === marker.id);
                const icon = found.icon ? found.icon : this.$searchlocator.icon;
                marker.setIcon(icon.inactive);
            });

            if (this.infowindow) {
                this.infowindows[0].closeAll();
            }

            if (item) {
                if (this.center) {
                    await this.animateTo(item.lat, item.lng);
                }

                // marker
                const icon = item.icon ? item.icon : this.$searchlocator.icon;
                const selected = this.markers.find((marker) => marker.id === item.id);

                if (selected) {
                    selected.setIcon(icon.active);
                }

                // infowindow
                if (this.infowindow) {
                    const selected = this.infowindows.find((infowindow) => infowindow.id === item.id);

                    if (selected) {
                        selected.open(false);
                    }
                }
            }

            if (fireEvent) {
                this.$emit('select', item);
            }

            this.$nextTick(() => {
                this.setStatus('ready');
            });
        },

        hasMoved(lat, lng) {
            const bounds = this.map.getBounds();
            const center = this.map.getCenter();
            const position = `${center.lat()},${center.lng()}`;

            if (this.historyBounds !== bounds.toUrlValue() || position !== `${lat},${lng}`) {
                this.historyCenter = `${lat},${lng}`;
                this.historyBounds = bounds.toUrlValue();
                return true;
            }

            return false;
        },

        async initialize() {
            this.gmaps = await loadGoogleMaps(
                this.apiKey,
                this.$searchlocator.options,
                ['https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/markerclusterer.js'],
            );
            this.map = createMap(this.$el);

            this.createMarkers(this.items);

            this.gmaps.event.addListener(this.map, 'click', () => {
                this.doSelect(null);
            });

            this.gmaps.event.addListener(this.map, 'idle', () => {
                if (this.isStatus('ready')) {
                    const center = this.map.getCenter();

                    if (this.hasMoved(center.lat(), center.lng())) {
                        this.$emit('search', { bounds: this.map.getBounds().toUrlValue() });
                    }
                } else {
                    this.setStatus('ready', true);
                }
            });
        },
        setItems(items) {
            this.items = items;
        }
    },

    async mounted() {
        await this.initialize();
    },
};
</script>
